import React from 'react';
import { Modal } from '@/components/ui';
import { BookOpen, CheckCircle2, XCircle } from 'lucide-react';
import { cn } from '@/utils/cn';

interface AIGuideModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const guideData = [
  {
    id: 'MAINTENANCE',
    name: 'Bảo dưỡng',
    formula: 'Hiện trạng + Yêu cầu xử lý / SOP',
    wrong: 'Cách bón phân cho cỏ?',
    right: 'Anh ơi, thảm cỏ lá gừng mùa mưa này công nhân cứ cắt bị lẹm gốc, bón phân NPK thì loang lổ. Cho em cái SOP cắt tỉa mùa mưa với định mức phân bón cụ thể để ép công nhân làm cho chuẩn.',
    icon: 'ri-scissors-cut-line',
  },
  {
    id: 'COASTAL_TREE',
    name: 'Cây bóng mát',
    formula: 'Loài cây + Khoảng cách đến biển/Môi trường + Vấn đề đang gặp',
    wrong: 'Trồng cây bàng vuông thế nào?',
    right: 'Cây bàng vuông mới trồng cách biển 50m, gió đang thốc mạnh làm rách lá và héo ngọn. Xin giải pháp neo chống và xử lý xả mặn khẩn cấp.',
    icon: 'ri-tree-line',
  },
  {
    id: 'SHRUB',
    name: 'Cây Tầng thấp',
    formula: 'Mục đích + Môi trường (nắng/gió) + Yêu cầu bảo trì',
    wrong: 'Cây gì trồng viền đẹp?',
    right: 'Khu vực hồ bơi sát biển nắng gắt, em muốn trồng 1 viền cây cao 40cm. Không cần hoa rực rỡ nhưng form phải giữ được lâu, ít phải cắt tỉa và chịu được hơi muối. Tư vấn cho em 3 loại và khoảng cách trồng.',
    icon: 'ri-leaf-line',
  },
  {
    id: 'SOIL',
    name: 'Đất & Dinh dưỡng',
    formula: 'Loại đất + Lịch sử phân bón + Biểu hiện của rễ/lá',
    wrong: 'Cây chà là bị vàng lá bón phân gì?',
    right: 'Đất cát khu biệt thự tưới nước trôi tuột đi rất nhanh, đào lên thấy rễ cây chà là không phát triển, có mùi hôi ngai ngái. Tháng trước vừa tống đạm vào. Xin phác đồ cải tạo hệ vi sinh và giải cứu rễ.',
    icon: 'ri-earth-line',
  },
  {
    id: 'DIAGNOSIS',
    name: 'Chẩn đoán Hình ảnh',
    formula: '[Upload Ảnh] + Lịch sử chăm sóc (Tưới/Thuốc) + Triệu chứng',
    wrong: '[Gửi 1 tấm ảnh mờ tịt] Bệnh gì đây?',
    right: '[Kèm ảnh sắc nét] Cây phát tài núi bị đốm đen ở mép lá như hình. Vừa mưa dầm 3 ngày xong, hệ tưới vẫn đang để chạy tự động 2 lần/ngày. Xem giúp do nấm hay do úng rễ?',
    icon: 'ri-image-edit-line',
  },
  {
    id: 'PESTICIDE',
    name: 'Phun thuốc BVTV',
    formula: 'Tên sâu bệnh/Dấu hiệu + Mức độ + Yêu cầu an toàn',
    wrong: 'Xịt thuốc gì cho chuỗi ngọc?',
    right: 'Rệp sáp trắng bùng phát ở hàng rào chuỗi ngọc khu vực sát nhà hàng. Em cần loại thuốc lưu dẫn nào không có mùi hôi, thời gian cách ly ngắn để phun ban đêm mà sáng hôm sau khách vẫn ăn sáng bình thường.',
    icon: 'ri-flask-line',
  },
  {
    id: 'NURSERY',
    name: 'Vườn ươm',
    formula: 'Giai đoạn cây + Điều kiện ươm + Dấu hiệu bất thường',
    wrong: 'Tại sao giâm cành hoa giấy bị chết?',
    right: 'Lô giâm cành hoa giấy bị thối rễ hàng loạt ở tuần thứ 2. Giá thể đang dùng là 70% xơ dừa + 30% tro trấu, lưới lan che 60% nắng. Tỷ lệ giá thể này có gây bí rễ không? Cần đảo lại thế nào?',
    icon: 'ri-plant-line',
  },
  {
    id: 'SUPERVISOR',
    name: 'Thi công',
    formula: 'Hạng mục thi công + Sự cố phát sinh + Hướng xử lý dự kiến',
    wrong: 'Đào hố trồng cây kè bạc sâu bao nhiêu?',
    right: 'Nhà thầu đang đào hố trồng cây kè bạc, nhưng bên dưới đụng ngay lớp đá bàn, chỉ đào sâu được 50cm. Em định cho đắp mô đất lên thêm 30cm nữa để lấp bầu. Phương án đắp mô này có rủi ro ngã đổ về sau không?',
    icon: 'ri-hard-hat-line',
  },
  {
    id: 'QAQC',
    name: 'Chất lượng',
    formula: 'Bước thi công + Tiêu chuẩn cần đạt / Lỗi muốn phòng ngừa',
    wrong: 'Nghiệm thu cây dừa cần làm gì?',
    right: 'Ngày mai bắt đầu nghiệm thu lô cây dừa 4m đưa vào công trường. Cho em xin Checklist 5 bước kiểm tra bầu rễ và sâu bệnh để nhà thầu không cãi được.',
    icon: 'ri-shield-check-line',
  },
  {
    id: 'MEP',
    name: 'Điện Nước & Tưới',
    formula: 'Thông số (Áp/Ống/Bơm) + Hiện tượng lỗi',
    wrong: 'Béc tưới không lên nước phải làm sao?',
    right: 'Bơm 2HP, ống trục HDPE phi 49, nhưng 10 đầu béc pop-up ở cuối line tưới không nẩy lên được. Do hụt áp hay do rò rỉ ngầm? Cách test điểm rò rỉ nhanh nhất?',
    icon: 'ri-drop-line',
  },
  {
    id: 'MACHINERY',
    name: 'Cơ giới',
    formula: 'Yêu cầu công việc (Trọng lượng/Kích thước) + Ràng buộc mặt bằng',
    wrong: 'Trồng dừa dùng cẩu mấy tấn?',
    right: 'Cần cẩu cây dừa dài 7m, nặng 1.5 tấn vào hố cách lề đường 8 mét. Em nên gọi cẩu thùng 5 tấn hay phải dùng cẩu KATO? Cần lưu ý góc hạ cần thế nào cho an toàn chống lật?',
    icon: 'ri-truck-line',
  },
  {
    id: 'QS',
    name: 'Khối lượng & Báo giá',
    formula: 'Hạng mục + Khối lượng bản vẽ + Yêu cầu kiểm soát rủi ro',
    wrong: 'Trồng 500m2 cỏ mua bao nhiêu m2 là đủ?',
    right: 'Trồng 500m2 cỏ nhung nhật, nếu tính hao hụt do đường cắt viền cong và dặm vá sau 1 tháng bảo hành thì em nên nhập thực tế bao nhiêu m2 để không bị thiếu hụt?',
    icon: 'ri-calculator-line',
  },
  {
    id: 'PLANNER',
    name: 'Tiến độ & Kế hoạch',
    formula: 'Khối lượng tổng + Năng lực tổ đội hiện có + Ràng buộc thời gian',
    wrong: 'Trồng 200 cây mất bao lâu?',
    right: 'Cần trồng 200 cây bóng mát lớn trong 5 ngày. Hiện em có 1 cẩu, 1 máy xúc và 10 công nhân. Lập biểu đồ phân công (ai làm việc gì, mấy giờ) để kịp tiến độ mà máy móc không bị chờ nhau.',
    icon: 'ri-calendar-todo-line',
  },
  {
    id: 'SOP',
    name: 'SOP & Quy trình',
    formula: 'Mục tiêu quy trình + Thực trạng lỗi đang gặp',
    wrong: 'Cho xin quy trình nhổ cỏ.',
    right: 'Đội bảo dưỡng hay báo cáo sai về việc nhổ cỏ định kỳ. Hãy thiết kế 1 quy trình (SOP) kiểm tra chéo gồm 3 bước đơn giản, có yếu tố bắt buộc chụp ảnh tọa độ để công nhân buộc phải làm thật.',
    icon: 'ri-file-list-3-line',
  }
];

export function AIGuideModal({ isOpen, onClose }: AIGuideModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <div className="flex items-center gap-2 text-emerald-800">
          <BookOpen className="w-5 h-5 text-emerald-600" />
          <span>Sổ tay Đặt câu hỏi AI</span>
        </div>
      }
      size="3xl"
    >
      <div className="space-y-6 max-h-[70vh] overflow-y-auto pr-2 custom-scrollbar">
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 text-amber-900 shadow-sm">
          <p className="font-medium mb-1 flex items-center gap-2 sm:text-sm text-xs">
            <span className="text-xl">⚠️</span> Nguyên tắc "vàng" khi hỏi AI Landscape:
          </p>
          <p className="sm:text-sm text-xs">
            <strong>Đừng bắt AI đoán mò!</strong> Hãy cung cấp đầy đủ bối cảnh (hiện trạng, môi trường, thông số kỹ thuật, lịch sử chăm sóc) thay vì hỏi một câu chung chung. Câu hỏi càng thực chiến, AI trả lời càng sắc bén!
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {guideData.map((item, idx) => (
            <div key={item.id} className="bg-white border border-slate-200 rounded-xl p-4 hover:border-emerald-300 hover:shadow-md transition-all group relative overflow-hidden flex flex-col h-full">
              <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-bl from-emerald-50 to-transparent rounded-bl-3xl -z-0 opacity-0 group-hover:opacity-100 transition-opacity" />

              <div className="flex items-center gap-3 mb-4 relative z-10">
                <div className="w-10 h-10 rounded-xl bg-emerald-100 text-emerald-600 flex items-center justify-center shrink-0 shadow-sm border border-emerald-200/50">
                  <i className={cn(item.icon, "text-xl")} />
                </div>
                <div>
                  <h4 className="font-medium text-slate-800 sm:text-sm text-xs flex items-center gap-1.5">
                    <span className="text-emerald-500 font-medium">{idx + 1}.</span> {item.name}
                  </h4>
                  <p className="sm:text-sm text-xs text-slate-500">{item.id.toLowerCase()}</p>
                </div>
              </div>

              <div className="space-y-4 relative z-10 flex-1 flex flex-col">
                <div className="bg-slate-50 rounded-lg p-2.5 border border-slate-100">
                  <span className="sm:text-sm text-xs font-medium text-slate-500 block mb-1.5">Công thức</span>
                  <code className="sm:text-sm text-xs text-indigo-700 bg-indigo-50 px-2 py-1 rounded block">{item.formula}</code>
                </div>

                <div className="space-y-2.5 mt-auto">
                  <div className="flex gap-2 items-start">
                    <XCircle className="w-4 h-4 text-rose-500 shrink-0 mt-0.5" />
                    <p className="sm:text-sm text-xs text-slate-500 italic line-through decoration-rose-200">"{item.wrong}"</p>
                  </div>
                  <div className="flex gap-2 items-start bg-emerald-50/70 p-3 rounded-lg border border-emerald-100/80 shadow-sm">
                    <CheckCircle2 className="w-4 h-4 text-emerald-500 shrink-0 mt-0.5" />
                    <p className="sm:text-sm text-xs text-slate-800 leading-relaxed">"{item.right}"</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}
